import React, { useState, useEffect } from "react";
// import UnReadMessage from "./Buyer/UnRead";
// import ReadMessage from "./Buyer/Read";
// import ArchiveMessage from "./Buyer/Archive";

// import AMArchiveMessage from "./AMTPL/Archive";
// import AmUnReadMessage from "./AMTPL/UnRead";
// import AmReadMessages from "./AMTPL/Read";

import AmMessage from "./AMTPL/Index";
import Message from "./Buyer/Index";

const GPTradeMessageModule = () => {
  const [activeTab, setActiveTab] = useState("AMTPL Admin");
  const [filterType, setFilterType] = useState("All");
  const tabs = ["Buyer", "AMTPL Admin"];
  const getFilterTabs = () => {
    if (activeTab === "AMTPL Admin") {
      return ["All", "Unread"]; //, "Archive"
    } else if (activeTab === "Buyer") {
      return ["All", "Unread"]; //, "Archive"
    }
  };
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (tab === "Buyer") {
      setFilterType("All"); // Default for RFQ
    } else {
      setFilterType("All"); // Default for Requirements
    }
  };

  const handleFilterChange = (filter) => {
    // If the same filter is clicked again, unset it to refresh to default
    setFilterType(filterType === filter ? "All" : filter);
  };

  const renderTabContent = () => {
    if (activeTab === "AMTPL Admin") {
      switch (filterType) {
        case "Unread":
          return <AmMessage filter="Unread" />;
        case "All":
          return <AmMessage filter="All" />;
        case "Archive":
          return <AmMessage filter="Archive" />;
        default:
          return <AmMessage filter="" />;
      }
    } else if (activeTab === "Buyer") {
      switch (filterType) {
        case "Unread":
          return <Message filter="Unread" />;
        case "All":
          return <Message filter="All" />;
        case "Archive":
          return <Message filter="Archive" />;
        default:
          return <Message filter="" />;
      }
    }
  };

  return (
    <div className="buyer-layout">
      <div className="amtpl-tabs">
        <div className="content3">
          <main className="main-content">
            <div
              className="mb-3"
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                width: "100%",
              }}
            >
              {/* Left side tabs */}
              <div className="main-tab" style={{ marginRight: "20px" }}>
                <div>
                  {tabs.map((tab) => (
                    <button
                      key={tab}
                      className={`buttonclass ${
                        activeTab === tab ? "active" : "notactive"
                      }`}
                      onClick={() => handleTabChange(tab)}
                    >
                      {tab}
                    </button>
                  ))}
                </div>
              </div>
              {/* Right side filter tabs */}
              <div className="main-tab">
                <div>
                  {getFilterTabs().map((filter) => (
                    <button
                    key={filter}
                    className={`buttonclass ${
                      filterType === filter ? "active" : "notactive"
                    }`}
                    onClick={() => handleFilterChange(filter)}
                  >
                    {filter}
                  </button>
                  ))}
                </div>
              </div>
            </div>

            <div className="row">{renderTabContent()}</div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default GPTradeMessageModule;
